import moment from 'moment';
import React, { useEffect, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button } from 'reactstrap';
import socketIOClient from 'socket.io-client';
// import { io } from "socket.io-client"; // in case of any issue use this one
import { deleteFaxAction, getAllPendingFaxes } from '../../actions/Fax';
import utils from '../../lib/utils';

export default function ({ filterValues = {} }) {
  const user = useSelector(state => state.AppState.user);
  const token = localStorage.getItem('jwtToken') || null;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [io, setIo] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    const base_url = window.location.origin;
    const socket = socketIOClient.connect(base_url);
    socket.on('connect', () => {
      console.log('SOCKET Successfully connected!');
    });
    setIo(socket);
  }, []);
  useEffect(() => {
    getData();
  }, [filterValues]);
  useEffect(() => {
    let event = '';
    let { company, box, sender, receiver } = filterValues;
    if (io) {
      io.on('FAX_DELETE', ({ id }) => {
        setData(data => {
          console.log({ uuuuuuuuuuuuuuuuuuid: id });
          let temp = data.filter(fax => fax.uuid !== id);
          return [...temp];
        });
      });
      if (company) event = `company:${company}`;
      if (box) event = `box:${box}`;
      if (sender && sender.length > 2) event = `sender:${sender}`;
      if (receiver && receiver.length > 2) event = `receiver:${receiver}`;
      if (!event && user.role == 'superAdmin') event = 'FAX_UPDATED';
      console.log(`SUBSCRIBING TO ${event}`);
      if (event)
        io.on(event, ({ data }) => {
          if (data?.shouldDelete) {
            let uuid = data.uuid;
            setData(data => data.filter(fax => fax.uuid === uuid));
          }
          if (data && !data?.shouldDelete) {
            let uuid = data.uuid;
            setData(faxes => {
              let index = faxes.findIndex(fax => fax.uuid === uuid);
              if (index > -1) faxes[index] = data;
              else {
                faxes.unshift(data);
              }
              return [...faxes];
            });
          }
        });
    }

    return () => {
      console.log(`UNSUBSCRIBING TO ${event}`);
      if (io) io.off('FAX_DELETE');
      if (io && event) {
        io.off(event);
      }
    };
  }, [io, data, filterValues]);

  const getData = utils.debounce(async () => {
    const data = await dispatch(getAllPendingFaxes(token, filterValues));
    if (data) {
      setData([...data]);
    }
    setLoading(false);
  }, 600);
  const deleteFax = async (fax) => {
    const fax_uuid = fax.uuid
    await dispatch(deleteFaxAction(token, fax.uuid, fax.datacenter))
    // await dispatch(deleteFaxAction(token, fax.uuid, 'ny'))
    setData(data => {
      // console.log({ uuuuuuuuuuuuuuuuuuid: fax_uuid });
      let temp = data.filter(fax => fax.uuid !== fax_uuid);
      return [...temp];
    });
  }
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer">Date</th>
            <th className="cursor-pointer">Last Update</th>
            <th className="cursor-pointer">Sender Company</th>
            <th className="cursor-pointer">Receiver Company</th>
            <th className="cursor-pointer">Sender Edge Device Serial #</th>
            <th className="cursor-pointer">Receiver Edge Device Serial #</th>
            <th className="cursor-pointer">Sender #</th>
            <th className="cursor-pointer">Receiver #</th>
            <th className="cursor-pointer">Description</th>
            <th className="cursor-pointer">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length ? (
            data.map(fax => (
              <tr key={fax.uuid}>
                <td>{fax.date}</td>
                <td>{utils.getDateTimeFormat(fax.updatedAt, 'both')}</td>
                <td>{fax.senderCompany}</td>
                <td>{fax.receiverCompany}</td>
                <td>{fax.senderBox}</td>
                <td>{fax.receiverBox}</td>
                <td>{fax.sender}</td>
                <td>{fax.receiver}</td>
                <td>{fax.description}</td>
                <td><Button onClick={() => deleteFax(fax)} color="danger">Delete</Button></td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  {loading ? 'Loading...' : 'No Faxes Found'}
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
